"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.plansForUSMedium = exports.plansForCurrency = void 0;
const plans_1 = require("./plans");
exports.plansForCurrency = {
    GBP: {
        personal: {
            current: plans_1.personalPlanIdGB,
        },
        booster: {
            current: plans_1.boosterPlanIdGB,
        },
        mega: {
            current: plans_1.megaPlanIdGB,
        },
        business: {
            current: plans_1.businessPlanIdGB,
        },
        family: {
            current: plans_1.familyPlanIdGB,
        },
    },
    USD: {
        personal: {
            current: plans_1.personalPlanIdUS,
        },
        booster: {
            current: plans_1.boosterPlanIdUS,
        },
        mega: {
            current: plans_1.megaPlanIdUS,
        },
        business: {
            current: plans_1.businessPlanIdUS,
        },
        family: {
            current: plans_1.familyPlanIdUS,
        },
    },
    EUR: {
        personal: {
            current: plans_1.personalPlanIdEU,
        },
        booster: {
            current: plans_1.boosterPlanIdEU,
        },
        mega: {
            current: plans_1.megaPlanIdEU,
        },
        business: {
            current: plans_1.businessPlanIdEU,
        },
        family: {
            current: plans_1.familyPlanIdEU,
        },
    },
    AUD: {
        personal: {
            current: plans_1.personalPlanIdAU,
        },
        booster: {
            current: plans_1.boosterPlanIdAU,
        },
        mega: {
            current: plans_1.megaPlanIdAU,
        },
        business: {
            current: plans_1.businessPlanIdAU,
        },
        family: {
            current: plans_1.familyPlanIdAU,
        },
    },
    CAD: {
        personal: {
            current: plans_1.personalPlanIdCA,
        },
        booster: {
            current: plans_1.boosterPlanIdCA,
        },
        mega: {
            current: plans_1.megaPlanIdCA,
        },
        business: {
            current: plans_1.businessPlanIdCA,
        },
        family: {
            current: plans_1.familyPlanIdCA,
        },
    },
};
exports.plansForUSMedium = {
    personal: {
        current: plans_1.personalPlanIdUSMedium,
    },
    booster: {
        current: plans_1.boosterPlanIdUSMedium,
    },
    mega: {
        current: plans_1.megaPlanIdUSMedium,
    },
    business: {
        current: plans_1.businessPlanIdUSDMedium,
    },
    family: {
        current: plans_1.familyPlanIdUSMedium,
    },
};
//# sourceMappingURL=data:application/json;base64,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